import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { useTranslations } from 'next-intl';
import React from 'react';

type ClearFiltersButtonProps = {
  onClick: (e: MouseEvent) => void;
  fullWidth: boolean;
  showClearAllFiltersButton?: string | number;
};

export const ClearFiltersButton = ({
  onClick,
  fullWidth = false,
  showClearAllFiltersButton
}: ClearFiltersButtonProps) => {
  const t = useTranslations();

  const clearFiltersBtnText = showClearAllFiltersButton
    ? t('MULTI_SELECT_CLEAR_ALL_FILTERS')
    : t('USERROLEMANAGEMENT_CLEARFILTER');

  return (
    <CatButton
      variant="ghost"
      onClick={onClick}
      data-testid="notification-clear-button"
      fullWidth={fullWidth}
      className={fullWidth ? 'mt-2' : undefined}
    >
      {clearFiltersBtnText}
    </CatButton>
  );
};
